// extracted by mini-css-extract-plugin
module.exports = {"seoHeading":"_8UtgF"};